<template>
    <div class="home-component">
        <div class="app-header-nav-bar">
                <div class="spacer"></div>
                <div class="container">
                    <a href="event-schedule" class="your-account-nav-bar"> イベントスケジュール</a>
                </div>
        </div>

        <div class="app-header">
            <img class="session-detail-component-header-logo" src="./../assets/elevate-logo.png" alt="Elevate logo" height="150">
        </div>

        <div class="enter-membership-form">
            <div class="upcoming-events-title">
                ELEVATE: Social
            </div>

            <div class="upcoming-events-subtitle">
                サウナ×アイスバス×ヨガ×DJ
            </div>

            <div class="upcoming-events-date">
                2024年2月4日  (16:30〜19:00)
            </div>

            <hr class="divider">

            <div class="upcoming-events-coupons">
                招待割引
            </div>

            <div v-if="docs.length == 0 && docs != undefined" class="upcoming-events-coupons-subtitle">
                招待コードを使用して友人がELEVATEアカウントにサインアップすると、イベントが10%オフになるクーポンをお互いに受け取ることができます。
            </div>
            <div v-if="docs.length > 0" class="upcoming-events-coupons-subtitle">
                 {{ docs.length }} 枚の招待割引クーポンを持っています。招待コードを使用して友人がELEVATEアカウントにサインアップすると、イベントが10%オフになるクーポンをお互いに受け取ることができます。
            </div>

            <div class="coupons-container">
                <div class="coupons" v-for="doc in docs" :key="doc.id">
                <div class="coupons-container">
                    <img v-if="doc.data()['title'] == 'Referred coupon'" class="referral_coupon" src="./../assets/elevate-coupon.png" alt="Referral" height="150">
                    <img v-if="doc.data()['title'] == 'Referral coupon'" class="referral_coupon" src="./../assets/elevate-coupon.png" alt="Referral" height="150">
                </div>
            </div>
            </div>

            <label v-if="docs.length > 0" class="waiver-check-box-container">
                <input type="checkbox" name="waiver-check-box" id="waiver-check-box" checked/>
                今回のイベントに招待割引クーポンを１枚使う <br> <br>    
            </label>
            

            <hr class="divider">

            <div class="sign-up-container">
               
                <div class="spacer"></div>
                <button @click="clickedNextEvent" class="sign-up"> 予約する</button>
            </div>
            

        </div>
        
    </div>
</template>

<style scoped>

.text-container {
    text-align: left;
}

.referral_coupon {
    margin-left: 20px;
}

.coupons-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 15px;
}

.waiver-check-box-container {
    margin-left: 20px;
    font-family:  SFPRoRegular;
        font-size: 12pt;
        color: white;
}

.hr {
    display: none;
}

.divider {
    margin-left: 20px;
    margin-right: 20px;
}

.sign-up-container {
    display: flex;
    justify-content: space-between;
}

    .sign-up {
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 20px;
        margin-bottom:16px;
        height: 40px;
        cursor:pointer;
        background-color: rgb(225, 228, 118);
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 200px
    }

    .sign-up:hover {
        background: #9c9e2b;
    }   


    .upcoming-events-gallery {
        display: grid;
        grid-area: 1 / 1;
        grid-template-columns: 320px 1fr 320px 1fr;
        grid-gap: 40px;
    }

    .upcoming-event-feb-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        background: none; 
        border: none;
    }

    .upcoming-events-title {
        font-family:  SFPRoSemiBold;
        font-size: 30pt;
        padding-left: 20px;
        padding-top: 20px;
        padding-right: 20px;
    }

     .upcoming-events-subtitle {
        font-family:  SFPRoRegular;
        font-size: 22pt;
        padding-left: 20px;
        padding-bottom: 10px;
        padding-right: 20px;
        color: white;
    }

    .upcoming-events-coupons {
        font-family:  SFPRoSemibold;
        font-size: 22pt;
        padding-left: 20px;
        padding-top: 20px;
        padding-bottom: 10px;
        padding-right: 20px;
        color: white;
    }

    .upcoming-events-coupons-subtitle {
        font-family:  SFPRoRegular;
        font-size: 14pt;
        padding-left: 20px;
        padding-bottom: 28px;
        padding-right: 20px;
        color: white;
    }

    .upcoming-events-date {
        font-family:  SFPRoRegular;
        font-size: 14pt;
        padding-left: 20px;
        padding-bottom: 20px;
        padding-right: 20px;
        color: white;
    }
    
    .next-event-photo {
        width: 300px;
        height: 300px;
        border-radius: 12pt;
        object-fit: cover;
        cursor: pointer;
    }

    .event-subtitle {
        padding-bottom: 10px;
    }

    .event-photo {
        overflow: hidden;  
        border-radius: 12pt;
        background-color: red;  
        background: none; 
        border: none;
    }

    .event-date {
        color: white;
        font-size: 14pt;
        font-family:  SFPRoLight;
        padding-bottom: 10px;
        padding-top: 4px;
    }

.event-title {
        color: white;
        font-size: 16pt;
        font-family:  SFPRoSemiBold;
    }

    .next-event-photo:hover {
    transform: scale(1.05); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    }
    
    .next-event-photo {
        
    display: block;
    transition: transform .4s;   /* smoother zoom */
}

    .event-subtitle {
        color: white;
        font-size: 16pt;
        font-family:  SFPRoRegular;
    }

    .nav-buttons {
        padding-right: 16px;
        display: flex;
        gap: 10px;
    }

    .enter-membership-form {
        background-color: rgb(35,32,38);
        /* display: flex; */
        width:auto;
        margin-left:15px;
        margin-right:15px;
        margin-top: 50px;
        padding-bottom: 20px;
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
        border-radius: 10px;
    }

    .upcoming-events-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 18pt;
    }

    .your-account-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 18pt;
        margin-right: 16px
    }

    .upcoming-events-title {
        color: white;
    }

    .home-component {
        min-height: calc(100vh - 110px);
        /* display: flex; */
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 20pt;
        background-image: url("./../assets/elevate-tiling.png");
    }

    .waiver-link {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 14pt;
    }

    .button-container {
        display: flex;
         justify-content: center;
         margin-top: 35pt;
    }

    .session-detail-component-header-logo {
        height: 100pt;
        align-items: left;
        object-fit: contain;
        display: flex;
        justify-content: left;
        padding-left: 20pt;
    }

    .app-header {
        height: 100pt;
        width: 100%;
        justify-content: space-between;
        align-items: left;
        display: flex;
        
    }

    .app-header-nav-bar {
        height: 10pt;
        width: auto;
        justify-content: space-between;
        align-items: left;
        padding-right: 10pt;
        display: flex;
    }
    
    .membership-number-text-field {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 15pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .password-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 12pt;
        margin-bottom: 20pt;
        margin-top: 4pt;
    }

    .membership-number-submit {
        height: 40px;
        background-color: rgb(225, 228, 99);
        cursor: pointer;
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 150pt;
        align-items: center;
        justify-content: center;
    }

    @media only screen and (max-width: 1000px) {
        .container {
        display: flex;
        flex-direction: column;
   }
}

@media only screen and (max-width: 1000px) {
   .upcoming-events-gallery {
        grid-template-columns: 1fr;
   }

   .hr {
    display: flex;
    width: 100%;
}
}

@media only screen and (max-width: 1000px) {
    .upcoming-event-feb-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: row;
    }
    
    .next-event-photo {
        width: 100px;
        height: 100px;
        margin-right: 10px;
    }
}



.sign-up-for-membership-page {
    font-family: SFPRoRegular;
    color: white;
    font-size: 14pt;
    margin-top: 5pt;
}

.member-log-in-title {
    font-family: SFPRoBold;
    color: white;
    font-size: 18pt;
    margin-top: 50pt;
    text-align: left;
    display: flex;
}

</style>

<script setup>
import { useRouter } from "vue-router";
import { useUserStore } from "@/piniastore";
import { collection, query, where, getDocs } from "firebase/firestore";
import { ref } from 'vue';
import { onMounted } from "vue";
import { db }  from '../main.js'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

    const router = useRouter();
    const store = useUserStore();

    const docs = ref([]); // Create a ref for 'docs'

    onMounted(async () => {
        NProgress.start()
        const couponsRef = collection(db, "coupons");
        const queryReferral = query(couponsRef, where("owner_id", "==", store.user.uid));

            getDocs(queryReferral)
                .then((response) => {
                    NProgress.done()
                    docs.value = response.docs;
                })
                .catch((error) => {
                    NProgress.done()
                    alert(error.message)
                })

 })

function clickedNextEvent() { 
    if (document.getElementById("waiver-check-box")) {
        const userCheckedCoupon = document.getElementById("waiver-check-box").checked;
        if (userCheckedCoupon) {
            window.location.href = "https://buy.stripe.com/14k00B3AK6PdgsE9AJ"
        } else {
            window.location.href = "https://buy.stripe.com/7sIbJjb3c4H56S4008"
        }
    } else {
        window.location.href = "https://buy.stripe.com/7sIbJjb3c4H56S4008"
    }
    
    router.push('continue-on-stripe')
 } 
</script>

<script>
export default {
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>
